import { useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INITIAL_FORM = {
  name: "",
  phone: "",
  email: "",
  project_type: "Engineering Prototype",
  message: "",
};

const validate = (form) => {
  if (!form.name || !form.phone || !form.message) {
    return "Please fill name, phone and message.";
  }
  return null;
};

/**
 * useInquiryForm — encapsulates inquiry form state, validation and submission.
 */
export default function useInquiryForm() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const update = (patch) => setForm((f) => ({ ...f, ...patch }));

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const validationError = validate(form);
    if (validationError) {
      setStatus({ state: "error", msg: validationError });
      return;
    }

    setStatus({ state: "loading", msg: "" });
    try {
      const res = await fetch(`${API}/inquiries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("send_failed");
      setStatus({
        state: "success",
        msg: "Got it — we'll reach out within 24 hours. Drop the STL/STEP on WhatsApp for an instant quote.",
      });
      setForm(INITIAL_FORM);
    } catch (err) {
      console.warn("[useInquiryForm] submit failed:", err);
      setStatus({
        state: "error",
        msg: "Couldn't reach the studio. Please WhatsApp +91 80881 63846.",
      });
    }
  };

  return { form, status, update, submit };
}
